<template>
  <div>
    <px-lista-estoque :estoques="estoques"
                      :loading="loading"
                      :on-change-options="onChangeOptions"
                      :options-list="optionsList"
                      @update="onClickRefresh"/>
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import EstoqueService from './estoque-produto-service';
import ListaEstoque from './ListaEstoque.vue';

export default {
  mixins: [paginationMixin],
  props: {
    produtoId: Number,
    default: [],
  },
  data() {
    return {
      estoques: {
        content: [],
        total: 0,
      },
      loading: false,
      listOptions: {
        page: 1,
        limit: 5,
        offset: 0,
        filter: '',
        sort: 'comprador.nome, deposito.descricao',
        sortDesc: true,
      },
      optionsList: {
        itemsPerPage: 5,
      },
    };
  },
  methods: {
    onChangeFilter() {
      this.resetPage();
      this.getEstoques();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getEstoques();
    },
    onClickRefresh() {
      this.getEstoques();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getEstoques() {
      this.loading = true;

      this.listOptions.filter = this.stringFilter;

      const { limit, offset } = this.listOptions;
      return EstoqueService.list(this.produtoId, {
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.estoques = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxListaEstoque: ListaEstoque,
  },
};
</script>
